import React from 'react'
import ReactGA from 'react-ga'
import { useParams } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getColorByStationName } from '../../helpers/common'
import { NewIconArrow } from '../icons/NewIconArrow'
// import IconBrush from '../UI/IconBrush/IconBrush'
import style from './NewFlatCardTwoStates.module.scss'
import { NewFlatCardTwoStateCommercialProps } from './NewFlatCardTwoStates.types'

function NewFlatCardTwoStatesCommercial(
  card: NewFlatCardTwoStateCommercialProps
) {
  const { id } = useParams()

  const linkHandler = () => {
    const paramsName = id ? 'PIK projects link' : 'PIK projects link - main'

    ReactGA.ga(
      'send',
      'event',
      'client link',
      'PIK projects link',
      card['building-name']
    )
    ReactGA.ga('rbcspec.send', 'event', 'client link', 'click')

    ym('reachGoal', 'client link', {
      'client link': {
        [paramsName]: {
          [`Подборка ${id ? id : card.selectionId}`]: card['building-name'],
        },
      },
    })
  }

  return (
    <a
      href={card.url}
      className={`${style.NewFlatCardTwoStates} ${
        style[`NewFlatCardTwoStates--${card.state ? card.state : 'table'}`]
      }`}
      onClick={linkHandler}
      target='_blank'
    >
      {/* images */}
      <div className={[style.NewFlatCardTwoStates__img].join(' ')}>
        <img src={card.image2D} alt='План квартиры в 2d' />
      </div>

      {/* info */}
      <div className={style.NewFlatCardTwoStates__side}>
        <div className={style.NewFlatCardTwoStates__name}>
          <b>Помещение {card.area_value} м² </b>
        </div>
        <div className={style.NewFlatCardTwoStates__row}>
          {/* col-1 price */}
          <div className={style.NewFlatCardTwoStates__col}>
            <div className={style.NewFlatCardTwoStates__value}>
              <span>Стоимость</span>
              <span>от&nbsp;</span>
              <div className={style.NewFlatCardTwoStates__price}>
                <b>
                  {card.price_value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽
                </b>
              </div>
            </div>
            <div className={style.NewFlatCardTwoStates__value}>
              <span>Цена за м²</span>
              <span>от&nbsp;</span>
              <div className={style.NewFlatCardTwoStates__subprice}>
                <b>
                  {card.square_price.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽ м²
                </b>
              </div>
            </div>
          </div>

          <hr />

          {/* col-2 location */}
          <div className={style.NewFlatCardTwoStates__col}>
            <div className={style.NewFlatCardTwoStates__value}>
              {card['building-name']}
            </div>
            {card.l_metro_name && !card.noMetro ? (
              <div className={style.NewFlatCardTwoStates__value}>
                <div
                  className={style.NewFlatCardTwoStates__metro}
                  style={{
                    background: getColorByStationName(card.l_metro_name),
                  }}
                />
                {card.l_metro_name}
              </div>
            ) : (
              <div className={style.NewFlatCardTwoStates__value}>
                {card['l_locality-name']}
              </div>
            )}
          </div>

          {/* <hr /> */}

          {/* col-3 READY*/}
          {/* <div
            className={`${style.NewFlatCardTwoStates__col} ${style['NewFlatCardTwoStates__col--flex']}`}
          >
            <div className={style.NewFlatCardTwoStates__value}>
              {IS_READY
                ? 'Готовая квартира'
                : `Заселение до ${UF_READY_QUARTER} ${UF_BUILD_YEAR}`}
            </div>

            <div className={style.NewFlatCardTwoStates__value}>
              <div className={style.NewFlatCardTwoStates__finishing}>
                <IconBrush /> {UF_RENOVATION}{' '}
                {UF_RENOVATION !== 'Без отделки' &&
                UF_RENOVATION !== 'С мебелью' &&
                UF_RENOVATION !== 'Готовая отделка с мебелью'
                  ? 'отделка'
                  : ''}
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div className={style.NewFlatCardTwoStates__link}>
        <span className='btn btn--small btn--white no-hover'>Подробнее</span>
        <NewIconArrow />
      </div>
    </a>
  )
}

export default NewFlatCardTwoStatesCommercial
